import FacturaPage from '../pages/crud/FacturaPage'

const routes = [
       
     {
        name: 'FacturaPage', 
        path: '/crud/factura', 
        component: FacturaPage,  
        meta: {
            requiresAuth: true,
            permission: "FACTURA_MENU"
        }
     }
]

export default routes;
